import { createMemo, createSignal, onCleanup, onMount } from "solid-js";
import type { MentionData } from "./Mention";
import {
	PROFILE_MENTION_EVENT,
	type ProfileMentionEventDetail,
} from "./profilePanelEvents";

/** Listens for `chatevent` with {@link PROFILE_MENTION_EVENT} and drives {@link ProfilePanel}. */
export function useProfileMentionPanel() {
	const [profileMention, setProfileMention] = createSignal<MentionData | null>(
		null,
	);
	const isOpen = createMemo(() => profileMention() !== null);

	onMount(() => {
		const onChatEvent = (evt: Event) => {
			const e = evt as CustomEvent<ProfileMentionEventDetail>;
			if (e.detail?.type !== PROFILE_MENTION_EVENT || !e.detail.content) {
				return;
			}
			if (e.detail.content.is_open) {
				setProfileMention(e.detail.content.mention);
			}
		};
		document.addEventListener("chatevent", onChatEvent);
		onCleanup(() => document.removeEventListener("chatevent", onChatEvent));
	});

	return {
		profileMention,
		isOpen,
		close: () => setProfileMention(null),
		setProfileMention,
	};
}
